module.exports = __webpack_public_path__ + "media/images/error_header_bg-17e664375b2d3fc9b24edcdeadc62e16.gif";